import { ContactEntryPointState } from './ContactEntryPointsConfig';

export type EntryPointActions =
  | 'DELETE_ENTRY_POINT'
  | 'UPSERT_ENTRY_POINT'
  | 'GET_ENTRY_POINT'
  | 'LIST_ENTRY_POINTS'
  | 'GET_AVAILABLE_HOURS'
  | 'GET_QUEUES'
  | 'GET_AGENTS'
  | 'GET_FLOWS'
  | 'GET_PROMPTS'
  | 'SET_CUSTOMER_QUEUE_FLOWS'
  | 'LOADING_ENTRY_POINTS'
  | 'DELETING_ENTRY_POINT'
  | 'LIST_MENUS'
  | 'LOADING_MENUS'
  | 'GET_NUMBERS'
  | 'SET_AVAILABLE_NUMBERS'
  | 'SET_AVAILABLE_CUSTOM_HOURS'
  | 'SET_MESSAGE'
  | 'SET_WORKING_ENTRY_POINT'
  | 'LOADING_QUEUE_TREATMENT'
  | 'LIST_QUEUE_TREATMENT'
  | 'SET_DEFAULT_LANG';

export function entryPointReducer(
  state: ContactEntryPointState,
  action: { type: EntryPointActions; payload: any }
): ContactEntryPointState {
  switch (action.type) {
    case 'SET_WORKING_ENTRY_POINT': {
      return {
        ...state,
        workingEntryPoint: action.payload.workingEntryPoint,
      };
    }
    case 'DELETE_ENTRY_POINT': {
      // @todo Potentially remove entryPoint from list instead of listing again
      return {
        ...state,
        deletingEntryPoint: false,
      };
    }
    case 'DELETING_ENTRY_POINT': {
      // @todo Potentially remove entryPoint from list instead of listing again
      return {
        ...state,
        deletingEntryPoint: action.payload,
      };
    }
    case 'UPSERT_ENTRY_POINT': {
      // @todo Potentially append entryPoint in list instead of listing again

      return {
        ...state,
        entryPointList: [
          ...state.entryPointList.filter(ep => ep.key !== action.payload.entryPoint.key),
          action.payload.entryPoint,
        ],
      };
    }
    case 'GET_ENTRY_POINT': {
      // @todo append latest entryPoint to list so the newest content is there in state
      return {
        ...state,
        workingEntryPoint: action.payload.workingEntryPoint,
      };
    }
    case 'LOADING_ENTRY_POINTS': {
      return {
        ...state,
        loadingEntryPoints: action.payload,
      };
    }
    case 'LIST_ENTRY_POINTS': {
      return {
        ...state,
        entryPointsLoaded: true,
        loadingEntryPoints: false,
        entryPointList: action.payload.entryPointList,
      };
    }
    case 'GET_AVAILABLE_HOURS': {
      return {
        ...state,
        availableHoursLoaded: true,
        loadingAvailableHours: false,
        availableHours: action.payload.availableHours,
      };
    }
    case 'GET_QUEUES':
      return {
        ...state,
        queuesLoaded: true,
        queues: action.payload.queues,
      };
    case 'GET_AGENTS':
      return {
        ...state,
        agentsLoaded: true,
        agentQueues: action.payload.agentQueues,
      };
    case 'GET_FLOWS':
      return {
        ...state,
        flowsLoaded: true,
        flows: action.payload.flows,
      };
    case 'GET_PROMPTS':
      return {
        ...state,
        promptsLoaded: true,
        prompts: action.payload.prompts,
      };
    case 'SET_CUSTOMER_QUEUE_FLOWS':
      return {
        ...state,
        customerQueueFlows: action.payload.customerQueueFlows,
      };
    case 'LIST_MENUS': {
      return {
        ...state,
        menusLoaded: true,
        menuList: action.payload.menuList,
      };
    }
    case 'GET_NUMBERS':
      return {
        ...state,
        numbersLoaded: true,
        numbers: action.payload.numbers,
      };
    case 'SET_AVAILABLE_NUMBERS':
      return {
        ...state,
        availableNumbers: action.payload,
      };
    case 'SET_AVAILABLE_CUSTOM_HOURS':
      return {
        ...state,
        availableCustomHours: action.payload,
      };
    case 'SET_MESSAGE':
      return {
        ...state,
        message: action.payload.message,
      };
    case 'LOADING_QUEUE_TREATMENT': {
      return {
        ...state,
        loadingQueueTreatments: action.payload,
      };
    }
    case 'LIST_QUEUE_TREATMENT': {
      return {
        ...state,
        queueTreatmentLoaded: true,
        loadingQueueTreatments: false,
        queueTreatmentList: action.payload.queueTreatmentList,
      };
    }

    case 'SET_DEFAULT_LANG': {
      return {
        ...state,
        workingEntryPoint: {
          ...state.workingEntryPoint,
          defaultLang: action.payload.lang,
        },
      };
    }
    default:
      return state;
  }
}
